import React, { useState } from "react";

const APIRequestDemo = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [gameId, setGameId] = useState(2);

  // Function to get base URL without any routes
  const getBaseUrl = () => {
    const url = window.location.href;
    return url.split("/").slice(0, 3).join("/");
  };

  // Function to create links from response
  const createLinks = (responseData) => {
    // Check for the actual response structure (data.uid and data.hostid)
    if (!responseData?.data?.uid || !responseData?.data?.hostid) {
      return null;
    }

    const baseUrl = getBaseUrl();
    const uid = responseData.data.uid;
    const hostId = responseData.data.hostid;

    return {
      host: `${baseUrl}?uid=${uid}&host=${hostId}`,
      guest: `${baseUrl}?uid=${uid}`,
    };
  };

  const handleRequest = async (gameId = 2) => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      console.log(process.env);
      const token = process.env.REACT_APP_CREATE_SESSION_KEY;
      if (!token) {
        throw new Error(
          "Authentication token not found in environment variables",
        );
      }

      const apiUrl =
        process.env.REACT_APP_API_URL || "https://onlinegame.mitmach-krimi.de/api";
      const response = await fetch(`${apiUrl}/session/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          gameid: gameId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || "Failed to create session");
      }

      setResponse(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <div className="mb-4">
        <label className="block mb-2">
          Game ID:
          <input
            type="number"
            value={gameId}
            onChange={(e) => setGameId(parseInt(e.target.value))}
            className="ml-2 p-1 border rounded"
            min="1"
          />
        </label>
      </div>
      <button
        onClick={() => handleRequest(gameId)}
        disabled={loading}
        className="bg-blue-500 text-white p-2 rounded"
      >
        {loading ? "Loading..." : "Create Session"}
      </button>

      {error && (
        <div className="mt-4 p-2 bg-red-100 text-red-700 rounded">
          Error: {error}
        </div>
      )}

      {response && (
        <div className="mt-4">
          {createLinks(response) && (
            <div className="mb-4 p-4 bg-green-50 border-2 border-green-500 rounded">
              <h3 className="text-xl font-bold mb-3 text-green-800">
                Session Created Successfully!
              </h3>

              <div className="mb-3">
                <h4 className="font-semibold mb-1">Host Link:</h4>
                <a
                  href={createLinks(response).host}
                  className="text-blue-600 hover:text-blue-800 underline break-all text-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {createLinks(response).host}
                </a>
              </div>

              {/* <div>
                <h4 className="font-semibold mb-1">Guest Link:</h4>
                <a
                  href={createLinks(response).guest}
                  className="text-blue-600 hover:text-blue-800 underline break-all text-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {createLinks(response).guest}
                </a>
              </div> */}
            </div>
          )}

          <details className="mt-4">
            <summary className="cursor-pointer font-semibold">
              Show Raw Response
            </summary>
            <pre className="mt-2 p-2 bg-gray-100 rounded overflow-x-auto text-xs">
              {JSON.stringify(response, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
};

export default APIRequestDemo;
